import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './filters'
import store from './store/store'

// Vue.config.productionTip = false

import html2pdf from "html2pdf.js";
Vue.use(html2pdf);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
